export const FINANCE_REPORT_NODE = "financeReport";
export const FINANCE_REPORT_DEFAULTS = { title: "Финансовый отчёт", period: "latest" } as const;

export function normalizeFinanceReportAttrs(value: unknown): { title: string; period: string } {
  const attrs = value && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
  const title = typeof attrs.title === "string" ? attrs.title.replace(/[\u0000-\u001F\u007F]/g, " ").trim().slice(0, 180) : "";
  const period = typeof attrs.period === "string" && /^\d{4}-(0[1-9]|1[0-2])$/.test(attrs.period) ? attrs.period : "latest";
  return { title: title || FINANCE_REPORT_DEFAULTS.title, period };
}
